import { Box, Button, Grid, GridItem, Heading, Icon, SimpleGrid, Text } from '@chakra-ui/react'
import React from 'react'
import { useColorModeValue } from '../../../components/ui/color-mode'
import { FaStackOverflow } from 'react-icons/fa'
import { motion, useInView, animate } from 'framer-motion'
import { useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'

const MotionHeading = motion.create(Heading)

const MotionButton = motion.create(Button)
const MotionBox = motion.create(Box)
const MotionIcon = motion.create(Icon)

const Counter = ({ from, to, duration = 2, suffix = "" }) => {
    const nodeRef = useRef();
    const isInView = useInView(nodeRef, { once: true, margin: "-100px" });

    useEffect(() => {
        const node = nodeRef.current;
        if (isInView) {
            const controls = animate(from, to, {
                duration: duration,
                onUpdate(value) {
                    node.textContent = Math.round(value) + suffix;
                }
            });
            return () => controls.stop();
        }
    }, [from, to, duration, isInView, suffix]);

    return <span ref={nodeRef} />;
}
const OurStats = () => {

    const borderColor = useColorModeValue('gray.100', 'gray.900')
    const cardColor = useColorModeValue('purple.100', 'gray.900')
    const {t} = useTranslation()

    return (
        <Box
            px={{ md: '10%', '2xl': "19%", base: 4 }}
            pt={{'2xl' : 20, base: 20}}
        >
            <Box
                borderTop={'2px solid'}
                borderColor={borderColor}
                position={'relative'}
                px={{'2xl' : 10, base: 4}}
                pt={20}
            >
                <MotionBox
                    // initial={{ scale: 0 }}
                    // whileInView={{ scale: 1 }}
                    // transition={{ type: "spring", stiffness: 200, damping: 10 }}
                    viewport={{ once: true }}
                    bgColor={cardColor} p={4} position={'absolute'} top={-10} left={{'2xl' :'48%', md: '47%', base: '44%'}} rounded={'full'}>
                    <MotionIcon
                        color={useColorModeValue('purple.700', 'purple.500')} boxSize={{'2xl' : 12, base: 8}}>
                        <FaStackOverflow />
                    </MotionIcon>
                </MotionBox>

                <Grid gridTemplateColumns={{'md' : '1fr 1fr', base: '1fr'}} gap={6}>
                    <SimpleGrid gap={{'2xl':  10, base: 8}} columns={{'md': 3, base: 1}}>
                        <GridItem as={motion.div} initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} transition={{ duration: 0.5, delay: 0.1 }} viewport={{ once: true }}>
                            <Heading fontFamily={'Outfit'} fontSize={{'2xl' : '6xl', base: '5xl'}}>
                                <Counter from={0} to={85} suffix="%" />
                            </Heading>
                            <Text mt={{'2xl': 8, base: 4 }} fontFamily={'Onest'}  fontSize={{'2xl': 'md', md : 'sm'}}>
                                {t('statsDescription1')}
                            </Text>
                        </GridItem>
                        <GridItem as={motion.div} initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} transition={{ duration: 0.5, delay: 0.3 }} viewport={{ once: true }}>
                            <Heading fontFamily={'Outfit'} fontSize={{'2xl' : '6xl', base: '5xl'}}>
                                <Counter from={0} to={120} />
                            </Heading>
                            <Text mt={{'2xl': 8, base: 4 }} fontFamily={'Onest'} fontSize={{'2xl': 'md', md : 'sm'}}>
                                {t('statsDescription2')}
                            </Text>
                        </GridItem>
                        <GridItem as={motion.div} initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} transition={{ duration: 0.5, delay: 0.5 }} viewport={{ once: true }}>
                            <Heading fontFamily={'Outfit'} fontSize={{'2xl' : '6xl', base: '5xl'}}>
                                <Counter from={0} to={92} />
                            </Heading>
                            <Text mt={{'2xl': 8, base: 4 }} fontFamily={'Onest'} fontSize={{'2xl': 'md', md : 'sm'}}>
                                {t('statsDescription3')}
                            </Text>
                        </GridItem>
                    </SimpleGrid>
                    <GridItem px={{'2xl' : 10, base: 'none'}} borderLeft={{'2xl' : '2px solid', base: 'none'}} borderColor={{'2xl': borderColor, base: 'none'}}>
                        <MotionHeading
                            initial={{ opacity: 0, x: 20 }}
                            whileInView={{ opacity: 1, x: 0 }}
                            transition={{ duration: 0.6 }}
                            viewport={{ once: true }}
                            fontFamily={'Onest'} lineHeight={1.2} fontSize={{'2xl' : '4xl', base: '2xl'}}>
                            {t('statsTitle')}
                        </MotionHeading>

                        <MotionButton
                            // initial={{ opacity: 0, scale: 0.8 }}
                            // whileInView={{ opacity: 1, scale: 1 }}
                            // transition={{ duration: 0.5, delay: 0.2 }}
                            whileHover={{ scale: 1.05 }}
                            whileTap={{ scale: 0.95 }}
                            mt={10} size={{'2xl': 'xl', base: 'md'}} rounded={'full'} colorPalette={'purple'} fontFamily='Momo Trust Display'>
                            {t('statsCallToAction')}
                        </MotionButton>
                    </GridItem>
                </Grid>
            </Box>

        </Box>
    )
}

export default OurStats